import { useState, useEffect } from "react";
import CreateOrderForm from "./CreateOrderForm";
import axios from "axios";
import "../../../App.css";
import { getGlobalVar, setGlobalVar } from "../../config/Config";
import { useSelector, useDispatch } from "react-redux";
import { io } from "socket.io-client";

const NavOrderInside = ({
  setShowPopup,
  showPopup,
  itemsInCart,
  setItemsInCart,
  setCurrentCustomer,
  currentCustomer,
  prevCustomer,
  setPrevCustomer,
  prevOrder,
  setPrevOrder,
  setTotal,
  allProducts,
  user,
  sendOrderToBackend,
  setCurrentOrderRef,
  customerData,
}) => {
  const baseurl = getGlobalVar().url;

  const API_URL = baseurl + "/posapi/GetOrder/";
  const auth = JSON.parse(localStorage.getItem("auth"));
  const org = "?org=" + auth?.org;

  const Delete_API = baseurl + "/posapi/GetOrder/";
  const OrderedProductsAPI =
    baseurl + "/posapi/GetOrderedProducts" + org + "&order_ref=";
  const imgUrl = baseurl + "";

  // const orders = useSelector((state) => state.orders.orders);
  const [orders, setOrders] = useState([]);

  const dispatch = useDispatch();

  const setOrderList = (value) => {
    // dispatch(setOrders(value)); // Pass 5 as a parameter to increment
  };

  // const [orders, setOrders] = useState([]);
  const [globalVar, setValue] = useState(getGlobalVar());

  const SOCKET_SERVER_URL =
    process.env.REACT_APP_SOCKET_SERVER_URL || "http://defcon:5000";
  const socket = io(SOCKET_SERVER_URL);

  useEffect(() => {
    socket.on("receive_new_order", (msg) => {
      console.log(msg);
      fetchOrders();
    });

    // Cleanup on unmount
    return () => {
      socket.disconnect();
    };
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get(
        API_URL + org + "&status=false&is_archive=false",
        {
          headers: {
            Authorization: "Bearer " + globalVar.Token,
          },
        }
      );
      // Filter orders where status is false
      const filteredOrders = response.data.filter((order) => !order.status);
      setOrders(filteredOrders);
      setPrevOrder(filteredOrders);
      console.log("filtered orders: ", filteredOrders);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [setPrevOrder]);

  const onOrderResume = async (id) => {
    console.log("on resume order");
    try {
      // Find the selected order in the orders state
      const selectedOrder = orders.find((order) => order.id === id);

      if (selectedOrder) {
        // Set the current customer from the selected order
        console.log(selectedOrder);
        const selectedCustomer = await customerData.find(
          (customer) => customer.id === selectedOrder.customer
        );
        setCurrentOrderRef(selectedOrder.id);
        localStorage.setItem("actualOrderId", selectedOrder.id);
        const orderRef = localStorage.getItem("actualOrderId");
        // const orderRef = selectedOrder.id;

        const orderedProductsResponse = await axios.get(
          `${OrderedProductsAPI}${orderRef}`,
          {
            headers: {
              Authorization: "Bearer " + globalVar.Token,
            },
          }
        );

        const orderedProducts = orderedProductsResponse.data;
        const productsWithDetails = await Promise.all(
          orderedProducts.map(async (orderedProduct) => {
            const product = allProducts.find(
              (p) => p.id === orderedProduct.product.id
            );
            return {
              ...product,
              quantity: orderedProduct.quantity,
              price: orderedProduct.price || product.price,
              discount: orderedProduct.discount || 0,
            };
          })
        );
        const total = productsWithDetails.reduce(
          (acc, item) => acc + item.Cost * item.Quantity,
          0
        );
        setTotal(total);
        setItemsInCart(productsWithDetails);
        setCurrentCustomer(selectedCustomer);

        console.log("order ref", orderRef);
        console.log("previous order ", prevOrder);
        console.log("products with details", productsWithDetails);
        setShowPopup(false);
        setOrders(orders.filter((order) => order.id !== id));
        setPrevOrder(prevOrder);
      } else {
        console.error("Selected order not found in the orders list.");
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const deleteOrder = async (id) => {
    try {
      await axios.delete(`${Delete_API}${id}/` + org, {
        headers: {
          Authorization: "Bearer " + globalVar.Token,
        },
      });

      socket.emit("send_new_order", "Order Deleted");

      setOrders(orders.filter((order) => order.id !== id));
      setPrevOrder(prevOrder.filter((order) => order.id !== id));
      // console.log("orders",orders,"====================")
      if (orders.filter((order) => order.id !== id).length < 1) {
        console.log("no orders left");
        localStorage.removeItem("actualOrderId");
        setCurrentCustomer(null);
        setItemsInCart([]);
      }
      if (localStorage.getItem("actualOrderId") == id) {
        console.log("active order removed");
        localStorage.removeItem("actualOrderId");
        setCurrentCustomer(null);
        setItemsInCart([]);
      }
      console.log(`Order ${id} deleted successfully.`);
    } catch (error) {
      console.error(`Error deleting order ${id}:`, error);
    }
  };

  const onBackButtonClick = () => {
    setShowPopup(false);
    // window.location.reload();
  };

  return (
    <div className="nav-order-inside fixed  left-0 w-full h-screen z-10 flex justify-center items-center bg-gray-100">
      <div className=" bg-white w-full h-full p-8 overflow-y-auto shadow-md">
        <div className="mb-5 text-center">
          <button
            className="theme bg-blue-500 text-white py-2 px-4 rounded mr-4"
            onClick={onBackButtonClick}
          >
            Back
          </button>
          <button
            className="theme bg-green-500 text-white py-2 px-4 rounded"
            onClick={async () => {
              await sendOrderToBackend();
              setShowPopup(false);
            }}
          >
            Create Order
          </button>
        </div>

        <div className="current-orders text-center text-xl font-bold mb-4">
          Current Orders
        </div>
        <table className="table-auto w-full">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2">Order ID</th>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2">Receipt number</th>
              <th className="px-4 py-2">Customer</th>
              <th className="px-4 py-2">Employee</th>
              <th className="px-4 py-2">Total</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders.map((prevO) => (
                <tr key={prevO.id} className="border-t">
                  <td className="px-4 py-2">{prevO.id}</td>
                  <td className="px-4 py-2">{prevO.date}</td>
                  <td className="px-4 py-2">{prevO.order_ref}</td>
                  <td className="px-4 py-2">
                    {prevO.customer && typeof prevO.customer === "object"
                      ? `${prevO.customer.name}`
                      : prevO.customer
                      ? `${prevO.customer}`
                      : "Unknown Customer"}
                  </td>
                  <td className="px-4 py-2">{prevO.User}</td>
                  <td className="px-4 py-2">
                    {prevO.payment ? `${prevO.payment}` : "Unknown Payment"}
                  </td>
                  <td className="px-4 py-2">
                    {prevO.status ? "Completed" : "Pending"}
                  </td>
                  <td className="px-4 py-2 flex space-x-2">
                    <button
                      className="text-white rounded-lg px-4 py-2"
                      onClick={() => onOrderResume(prevO.id)}
                      style={{ background: "blue" }}
                    >
                      Resume
                    </button>
                    <button
                      className="text-white rounded-lg px-4 py-2"
                      onClick={() => deleteOrder(prevO.id)}
                      style={{ background: "red" }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No previous Orders
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NavOrderInside;
